"use client";

import { c as _c } from "react/compiler-runtime";
import { bn } from "@opensea/utils";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { MINIMUM_OFFER_PRICE, OFFER_MAX_DECIMALS } from "../../../constants";
export const BestOfferButton = t0 => {
  const $ = _c(17);
  const {
    className
  } = t0;
  const t = useTranslations("wallet.BestOfferButton");
  const {
    control,
    setValue
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "offers"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const offers = useWatch(t1);
  let t2;
  if ($[2] !== offers) {
    t2 = offerIndex => {
      const bestOffer = offers[offerIndex]?.bestOffer;
      const traitBestOffer = offers[offerIndex]?.traitTopOfferPrice;
      return bn(Math.max(traitBestOffer ?? bestOffer ?? 0, MINIMUM_OFFER_PRICE)).decimalPlaces(OFFER_MAX_DECIMALS).toNumber();
    };
    $[2] = offers;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getBestOffer = t2;
  let t3;
  if ($[4] !== getBestOffer || $[5] !== offers || $[6] !== setValue) {
    t3 = () => {
      offers.forEach((_, index) => {
        setValue(`offers.${index}.price`, getBestOffer(index), {
          shouldValidate: true
        });
      });
    };
    $[4] = getBestOffer;
    $[5] = offers;
    $[6] = setValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleApplyToAll = t3;
  let t4;
  if ($[8] !== offers) {
    t4 = offers.some(_temp);
    $[8] = offers;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const hasTraitOffers = t4;
  let t5;
  if ($[10] !== hasTraitOffers || $[11] !== t) {
    t5 = hasTraitOffers ? t("topTraitOffer") : t("topOffer");
    $[10] = hasTraitOffers;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== className || $[14] !== handleApplyToAll || $[15] !== t5) {
    t6 = <Button className={className} onClick={handleApplyToAll} size="sm" variant="secondary">{t5}</Button>;
    $[13] = className;
    $[14] = handleApplyToAll;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
function _temp(offer) {
  return offer?.traitTopOfferPrice;
}